import "./style.js"
import {SpinnerComponent, SpinnerContainer} from "./style";

const Spinner = () => {
    return (
        <SpinnerContainer>
            <SpinnerComponent/>
        </SpinnerContainer>
    );
};

export default Spinner;
